var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStep = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.938657 12.5357C1.37488 14.2487 2.07965 15.9999 3.99936 15.9999C5.91908 15.9999 6.62384 14.2487 7.06007 12.5357C7.11508 12.3197 7.06281 12.0918 6.91833 11.9172C6.77386 11.7425 6.55312 11.6406 6.31944 11.6406H1.67928C1.4456 11.6406 1.22487 11.7425 1.08039 11.9172C0.935914 12.0918 0.883639 12.3197 0.938657 12.5357ZM3.99965 14.5508C3.70769 14.5508 3.20144 14.5508 2.6866 13.0897H5.31281C4.79798 14.5508 4.29173 14.5508 3.99977 14.5508H3.99971H3.99965Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.371391 9.55807C0.42529 9.91478 0.746708 10.1796 1.12568 10.1796H6.87432C7.25334 10.1796 7.57476 9.91478 7.62861 9.55807C7.69516 9.11747 7.76257 8.63715 7.83466 8.08979V8.0897C8.26606 4.81 7.85228 2.46576 6.60487 1.1222C5.92327 0.388057 5.02252 0 4 0C2.97748 0 2.07673 0.388057 1.39513 1.1222C0.147714 2.46576 -0.26606 4.80995 0.165342 8.08979C0.237632 8.6385 0.305045 9.11877 0.371391 9.55807ZM6.32253 7.90972C6.28412 8.20152 6.24709 8.4737 6.21081 8.73057H1.78941C1.75324 8.47408 1.7162 8.2019 1.6777 7.90982C1.3135 5.14087 1.61897 3.07084 2.53781 2.08113C2.92719 1.66173 3.4192 1.44906 4.00011 1.44906C4.58102 1.44906 5.07303 1.66173 5.46242 2.08113C6.38125 3.07084 6.68672 5.14087 6.32253 7.90972Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStep);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/step.ca9775b27971a302c5e49ec1e0490352.svg";